import stringHelpers from "../../utilities/stringHelpers";
import formUtilities from "../../utilities/formUtilities";

export const SiteGroupForm = ({ name, setName, numberOfSessions, setNumberOfSessions, notes, setNotes, concurrentLimitEnabled, setConcurrentLimitEnabled, maxAllowListEnabled, setMaxAllowListEnabled, maximumNumberOfAllowListEntries, setMaximumNumberOfAllowListEntries, onCancel, onSubmit }) => {

    return (
        <>
            <div className="card-body bg-light border-top details-container">
                <div className="row">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold  mt-1 mb-1">Name<span className="req"></span></p>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group mb-1">
                            <input required className="form-control mb-0" type="text" autoFocus={ true } value={ name } onChange={ (e) => {
                                setName(e.target.value);
                                formUtilities.requiredField(e.target.parentNode, e.target.value)
                            } } />
                            <small className='invalid-feedback text-danger'>Please enter a name</small>
                        </div>
                    </div>
                </div>
               
                <div className="row mb-1">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold mb-1">Limit Concurrent Sessions</p>
                    </div>
                    <div className="col-md-6 col-12 custom-control custom-switch">
                        <input className="custom-control-input" type="checkbox" id="concurrent-enabling-switch" checked={ concurrentLimitEnabled } onChange={ () => setConcurrentLimitEnabled(!concurrentLimitEnabled)} />
                        <label className="custom-control-label ml-3" htmlFor="concurrent-enabling-switch"></label>
                    </div>
                </div>
                {
                    concurrentLimitEnabled &&
                    <div className="row">
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold  mt-1 mb-1">Maximum Concurrent Sessions<span className="req"></span></p>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="form-group mb-1">
                                <input min="0" required className="form-control mb-0" type="number" value={ numberOfSessions } onChange={ e => {
                                    setNumberOfSessions(e.target.value);
                                    formUtilities.requiredField(e.target.parentNode, e.target.value)
                                } } />
                                <small className='invalid-feedback text-danger'>Please enter a value</small>
                            </div>
                        </div>
                    </div>
                }

                <div className="row mb-1">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold mb-1">Limit Allow List Entries</p>
                    </div>
                    <div className="col-md-6 col-12 custom-control custom-switch">
                        <input className="custom-control-input" type="checkbox" id="max-allow-list-enabling-switch" checked={ maxAllowListEnabled } onChange={ () => setMaxAllowListEnabled(!maxAllowListEnabled)} />
                        <label className="custom-control-label ml-3" htmlFor="max-allow-list-enabling-switch"></label>
                    </div>
                </div>

                {
                    maxAllowListEnabled &&
                    <div className="row">
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold  mt-1 mb-1">Maximum Number Of Allow List Entries<span className="req"></span></p>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="form-group mb-1">
                                <input min="0" required className="form-control mb-0" type="number" value={ maximumNumberOfAllowListEntries } onChange={ e => {
                                    setMaximumNumberOfAllowListEntries(e.target.value)
                                    formUtilities.requiredField(e.target.parentNode, e.target.value)
                                } } />
                                <small className='invalid-feedback text-danger'>Please enter a value</small>
                            </div>
                        </div>
                    </div>
                }

                <div className="row">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold  mt-1 mb-1">Notes</p>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group mb-1">
                            <textarea rows={5} className="form-control mb-0" type="text" value={ notes } onChange={ (e) => setNotes(e.target.value) } />
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer border-top ">
                <div className="row client-edit-buttons">
                    <div className="col-12 col-sm-auto ml-auto  pl-0">
                        <div>
                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => onCancel() }>
                                <i className="fas fa-times"></i> Cancel
                            </button>
                            <button disabled={stringHelpers.isNullOrEmpty(name) || (concurrentLimitEnabled && stringHelpers.isNullOrEmpty(numberOfSessions)) || (maxAllowListEnabled && stringHelpers.isNullOrEmpty(maximumNumberOfAllowListEntries))} type="button" className="btn btn-success btn-sm ml-2" onClick={ () => onSubmit() }>
                                <i className="fas fa-check"></i> Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}